import _, { findIndex } from 'lodash';
import moment from 'moment';
import { useState } from 'react';
import { MRC_ACCREDITED_STUDY_TYPES } from '../actions/urlTypes';

import { EXPORT_NAME_CONSTANT } from '../constants';

export const numberWithCommas = x => {
  if (x !== undefined) {
    const parts = x.toString().split('.');
    parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  return 0;
};

export const renderWeight = (weightType, customWeights) => {
  if (weightType === 1) {
    return 'Population';
  }
  if (weightType === 2) {
    return 'Household';
  }

  if (customWeights) {
    return customWeights;
  }

  return '';
};

export const roundWeighted = value => {
  if (typeof value === 'number') {
    return Math.round(value * 10) / 10;
  }
  return '';
};

export const upperCaseIfString = val =>
  typeof val === 'string' || val instanceof String ? val.toUpperCase() : val;

export const encodeQueryString = val =>
  val
    .split(' ')
    .reduce((accumulator, currentValue) => {
      accumulator.push(encodeURIComponent(currentValue));
      return accumulator;
    }, [])
    .join(' ');

export const makeTextFile = text => {
  let textFile = null;
  const data = new Blob([text], { type: 'octet/stream' });
  // If we are replacing a previously generated file we need to manually
  // revoke the object URL to avoid memory leaks.
  if (textFile !== null) {
    window.URL.revokeObjectURL(textFile);
  }
  textFile = window.URL.createObjectURL(data);
  return textFile;
};

export const copyContent = data => {
  document.oncopy = event => {
    event.clipboardData.setData('Text', data);
    event.preventDefault();
  };
  document.execCommand('Copy');
  document.oncopy = undefined;
};

export const getExportFieldDate = fieldDate => {
  const customDate = new Date(fieldDate);
  const dd = customDate.getDate();
  const mm = customDate.getMonth() + 1;
  return `${mm < 10 ? `0${mm}` : mm}/${
    dd < 10 ? `0${dd}` : dd
  }/${customDate.getFullYear()}`;
};

export const getExportStudyType = studyInfo => {
  if (studyInfo.sy > 2012) {
    return 'SimmonsConnect';
  }
  if (studyInfo.sd.includes('SLCL')) {
    return 'SLOB';
  }
  return 'Booklet';
};

export const filterStudyList = (studies, featureID) => {
  return _.filter(studies, item => item.pm.indexOf(featureID) !== -1);
};

export const isFeaturePresent = (featureId, features) => {
  let isFeaturesPresentBol = false;
  if (features === undefined) {
    return false;
  }
  for (let i = 0; i < features.length; i += 1) {
    if (features[i] === featureId) {
      isFeaturesPresentBol = true;
      break;
    }
  }
  return isFeaturesPresentBol;
};

export const isModulePresent = (moduleId, modules) => {
  if (modules === undefined || modules.length === 0) {
    return false;
  }
  const isFeaturesPresentBol = modules.includes(moduleId);
  return isFeaturesPresentBol;
};

export const isAllFeaturePresent = (allFeatureId, allFeatures) => {
  if (allFeatures === undefined || allFeatures.length === 0) {
    return false;
  }
  if (allFeatures.indexOf(allFeatureId) > -1) {
    return true;
  }
  return false;
};

export const formatJson = (responseData, filterLength) => {
  const attitudeData = Object.entries(responseData);
  const formatedJsondata = [];
  const formatedAttitudinalData = [];
  const defaultSelectedExpression = [];
  const defaultSelectedObject = [];

  attitudeData.forEach(data => {
    const children = [];
    data[1].forEach(innerData => {
      const child = {
        value: innerData.expression,
        label:
          innerData.text.length > filterLength
            ? innerData.text.substr(0, filterLength).concat('...')
            : innerData.text,
        title: innerData.text,
        templateId: innerData.templateId,
        keyword: innerData.keyword,
      };
      if (innerData.templateId > 0) {
        innerData.default = false;
      }
      if (innerData.default) {
        defaultSelectedExpression.push(innerData.expression);
        defaultSelectedObject.push(child);
      }
      children.push(child);
    });
    const parent = {
      value: data[0],
      label: data[0],
      children,
    };
    if (parent.children[0].templateId === 0) {
      formatedJsondata.push(parent);
    } else {
      formatedAttitudinalData.push(parent);
    }
  });
  const finalJsondata = {
    defaultSelectedExpression,
    defaultSelectedObject,
    formatedJsondata,
    formatedJsonAttitudinalData: formatedAttitudinalData,
  };
  return {
    finalJsondata,
  };
};

// array = array for compare , expression = key name , value = value to compare
export const findObjectIndexInArray = (array, expression, value) => {
  const index = array.indexOf(array.find(x => x[expression] === value));
  return index;
};

export const nthOccurrence = (string, char, nth) => {
  const firstIndex = string.indexOf(char);
  const lengthUptoFirstIndex = firstIndex + 1;

  if (nth !== 1) {
    const stringAfterFirstOccurrence = string.slice(lengthUptoFirstIndex);
    const nextOccurrence = nthOccurrence(
      stringAfterFirstOccurrence,
      char,
      nth - 1
    );

    if (nextOccurrence > -1) {
      return lengthUptoFirstIndex + nextOccurrence;
    }
    return -1;
  }
  return firstIndex;
};

export const takeOneDecimal = (value, precision) => {
  if (typeof value === 'undefined') {
    return '';
  }
  const floatValue = Number.parseFloat(value).toFixed(precision);
  return `${floatValue}%`;
};

export const formatIndexRangeFilter = rangeFilter => {
  let filterValue;
  switch (rangeFilter.selectedOption) {
    case 'Highest':
      filterValue = '>';
      break;
    case 'Greater Than':
      filterValue = '>';
      break;
    case 'Less Than':
      filterValue = '<';
      break;
    case 'Equals':
      filterValue = '=';
      break;
    case 'Range':
      filterValue = '//';
      break;
    default:
      filterValue = '>';
  }
  return `${filterValue + rangeFilter.value.join()}`;
};

export const filterStudies = (studies, keyword) => {
  const newOrderedStudies = [];
  _.forEach(studies, study => {
    const clonedStudy = _.cloneDeep(study);
    const filteredList = study.sl.filter(
      studyData => !studyData.st.toLowerCase().includes(keyword)
    );
    clonedStudy.sl = filteredList;
    newOrderedStudies.push(clonedStudy);
  });
  return newOrderedStudies;
};

export const reformatSpcArray = arr => {
  let modifiedString = '';
  const newArray = [];
  let newCount = 0;
  let openBraces = 0;
  let closedBraces = 0;

  for (let i = 0; i < arr.length; i += 1) {
    const lineArr = arr[i];
    for (let j = 0; j < lineArr.length; j += 1) {
      const ch = lineArr[j];
      if (ch === '(') {
        openBraces += 1;
      }
      if (ch === ')') {
        closedBraces += 1;
      }
    }

    if (lineArr.endsWith('...')) {
      modifiedString += arr[i];
      newArray[newCount] = modifiedString;
      newCount += 1;
      openBraces = 0;
      closedBraces = 0;
      modifiedString = '';
    } else if (openBraces === 0 && closedBraces === 0) {
      newArray[newCount] = arr[i];
      newCount += 1;
    } else if (openBraces !== closedBraces) {
      modifiedString += arr[i];
    } else if (
      openBraces !== 0 &&
      closedBraces !== 0 &&
      openBraces === closedBraces
    ) {
      modifiedString += arr[i];
      newArray[newCount] = modifiedString;
      newCount += 1;
      openBraces = 0;
      closedBraces = 0;
      modifiedString = '';
    }
  }

  return newArray;
};

export const getHighestIndexOrReachObject = (list, key) => {
  return _.reverse(
    _.sortBy(list, [
      function (o) {
        if (o.value !== undefined && o.value[key] !== undefined) {
          return o.value[key];
        }
        return -1;
      },
    ])
  );
};

export const getStudyFromStudies = (studies, productNo) => {
  const clonedStudies = _.cloneDeep(studies);
  for (let i = 0; i < clonedStudies.length; i += 1) {
    if (clonedStudies[i].sl !== undefined) {
      const selectedStudy = _.find(clonedStudies[i].sl, ['pn', productNo]);
      if (selectedStudy) {
        return selectedStudy;
      }
    }
  }
  return null;
};

export const getStudyFamiliesFromStudies = studies => {
  const clonedStudies = _.cloneDeep(studies);
  const studyFamilies = [];
  for (let i = 0; i < clonedStudies.length; i += 1) {
    if (clonedStudies[i] !== undefined) {
      studyFamilies.push({
        id: clonedStudies[i].id,
        desc: clonedStudies[i].sgd,
      });
    }
  }
  return studyFamilies;
};

export const getStudyFamilyIdForGivenProductNo = (productNo, studies) => {
  const clonedStudies = _.cloneDeep(studies);
  let selectedFamilyId = -1;
  _.forEach(clonedStudies, studyFamily => {
    const familyId = studyFamily.id;
    _.forEach(studyFamily.sl, study => {
      if (study.pn === productNo) {
        selectedFamilyId = familyId;
      }
    });
  });
  return selectedFamilyId;
};

export const getFiltersForGivenFamilyId = (filters, studyFamilyId) => {
  const selectedFilters = _.find(filters, { studyFamilyId });
  if (selectedFilters !== undefined) {
    return selectedFilters.filters;
  }
  return [];
};

export const getStudiesAsList = studies => {
  const data = [];
  for (let i = 0; i < studies.length; i += 1) {
    data.push(...studies[i].sl);
  }
  return data;
};

// set weight type to one when it is greater than 2
export const setWeightTypeToOne = study => {
  if (study.wt > 2) {
    const modifiedStudy = _.cloneDeep(study);
    modifiedStudy.wt = 1;
    return modifiedStudy;
  }
  return study;
};

export const returnInitialStudy = (studies, featureID) => {
  const permittedStudyList = filterStudyList(studies, featureID);
  return permittedStudyList &&
    permittedStudyList.length > 0 &&
    permittedStudyList[0].sl.length > 0
    ? setWeightTypeToOne(permittedStudyList[0].sl[0])
    : {};
};

export const checkWeightType = weightTypes => {
  let weightType = '';
  if (weightTypes && weightTypes.dv !== 1) {
    weightType = `(${String(weightTypes.dv).slice(1)})`;
  }
  return weightType;
};

export const fetchWeightTypeObj = (weightTypeObjArr, wt) => {
  const weightTypeObj = weightTypeObjArr.filter(
    weightType => weightType.wt === wt
  );
  return weightTypeObj.length > 0 ? weightTypeObj[0] : weightTypeObjArr[0];
};

export const arrayToObject = (arr, keyField) =>
  Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item })));

export const _getCheckedDefination = (data = [], flag = 'isActive') => {
  return data.filter(item => item[flag]);
};

export const isStudyAccredited = sti => {
  if (MRC_ACCREDITED_STUDY_TYPES.includes(sti)) {
    return true;
  }
  return false;
};

export const checkDigitsTimeStamp = timestamp => {
  const newTimestamp =
    timestamp.toString() && timestamp.toString().length === 1
      ? `0${timestamp}`
      : `${timestamp}`;

  return newTimestamp;
};

export const exportFileTitle = moduleName => {
  const date = new Date();
  const month = date.getMonth() + 1;

  const dateFormat = `${checkDigitsTimeStamp(month)}-${checkDigitsTimeStamp(
    date.getDate()
  )}-${date.getFullYear()}`;
  const timeFormat = `${checkDigitsTimeStamp(
    date.getHours()
  )}${checkDigitsTimeStamp(date.getMinutes())}${checkDigitsTimeStamp(
    date.getSeconds()
  )}`;

  const title = `${EXPORT_NAME_CONSTANT}_${moduleName}_${dateFormat}_${timeFormat}`;
  return title;
};

export const validatePhoneNumber = phoneNumber => {
  const phoneNumberPattern = /^[0-9\b]+$/;
  return phoneNumberPattern.test(phoneNumber);
};

export const validateEmail = email => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateIpv4 = val =>{
  const pattern = /^(\\d{1,3})\\.(\\d{1,3})\\.(\\d{1,3})\\.(\\d{1,3})$/;
  return pattern.test(val);
}

export const getDefaultSelected = (field, value, options) => {
  if (value === '') {
    return '';
  }
  if (value !== '') {
    const obj = _.find(options, { value });
    return obj;
  }
};

export const validateLetters = value => {
  const re = /^[a-zA-Z ]+$/;
  return re.test(value);
};

export const validateNumberAndLetter = value => {
  const re = /^[0-9a-zA-Z]+$/;
  return re.test(value);
};
export const validateNumberAndLetterAndSpace = value => {
  const re = /^[0-9a-zA-Z ]+$/;
  return value && re.test(value);
};

export const useFormFields = initialState => {
  const [fields, setValues] = useState(initialState);

  return [
    fields,
    function (event) {
      setValues({
        ...fields,
        [event.target.id]: event.target.value,
      });
    },
  ];
};

export const enableInDevOnly = () => {
  const local =
    window.location.hostname === 'local.dev.insights.mrisimmons' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '' ||
    window.location.hostname === 'dev.insights.mrisimmons' ||
    window.location.hostname === 'qa1.insights.mrisimmons';
  if (local) return true;
  return process.env.NODE_ENV === 'development';
};

export const getOffsetDate = date => {
  const fieldDate = new Date(date);
  fieldDate.setMinutes(fieldDate.getMinutes() + fieldDate.getTimezoneOffset());
  return moment(fieldDate).format('MM/DD/YYYY');
};

export const CopyDataToClipBoard = (data, isTriggerCall, actionName) => {
  const textField = document.createElement('textarea');
  if (isTriggerCall) {
    actionName(data).then(res => {
      textField.innerText = res.data;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy', true, res);
      textField.remove();
    });
  } else {
    textField.innerText = data;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy', true, data);
    textField.remove();
  }
};

export const CopyDataToClipBoardModal = (data) => {
  const textField = document.createElement('textarea');
  textField.innerText = data;
  document.body.appendChild(textField);
  textField.select();
  textField.focus();
  document.execCommand('copy', true, data);
  textField.remove();
};
